// extracted by mini-css-extract-plugin
export var indeterminate = "_22-5";
export var md = "_22-4";
export var semantic = "_22-6";
export var sm = "_22-3";
export var text = "_22-7";
export var toggleInput = "_22-0";
export var toggleSwitch = "_22-1";
export var xs = "_22-2";